// PHPStorm doesn't like this, but theres no proper ESM way of importing the light version
import lottie from 'lottie-web/build/player/lottie_light.min.js'

class AnimatedGraphic {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError("Invalid element");
    }

    this.element = element;
    this.src = this.element.dataset.src ?? null;

    if (this.src && this.element) {
      this.init();
    }
  }

  init() {
    lottie.loadAnimation({
      container: this.element,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.src,
    });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  (document.querySelectorAll('.animated-image') ?? []).forEach(el => new AnimatedGraphic(el));
});

// export default AnimatedGraphic;
